<template>
    <div class="bg-white p-5 pb-1 mb-3 rounded container-fluid" id="newbootcamp">
        <div class="d-flex justify-content-between">
            <h3 class="page-title">{{ current_bootcamp ? 'Editar Bootcamp' : 'Nuevo Bootcamp' }}</h3>
            <button class="btn bg-utel-v2-secondary rounded" v-if="current_bootcamp" @click="onCancel">
                <i class="fa fa-xmark"></i>
            </button>
        </div>
        <div class="row my-4  rounded-8" :class="{'bg-utel-v2-secondary': !current_bootcamp}">
            <div class="mx-auto" :class="{'col-md-6': !current_bootcamp, 'col-md-12': !!current_bootcamp }">
                <div v-if="!current_bootcamp">
                    <h3>Agregar Bootcamp</h3>
                    <span>Completa el formulario para agregar un nuevo Bootcamp especificar algún aspecto relevante.</span>
                </div>

                <div class="row mt-4">
                    <div class="col-md-12">
                        <input type="text" v-model="bootcamp.title" class="form-control rounded-8 sin-borde" placeholder="Nombre del Bootcamp" required>
                        <small v-if="errors.title" class="text-danger">Debe ingresar el nombre del bootcamp</small>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-md-12">
                        <label class="bootcamp-label" for="bootcampdescriptioninput">Descripción</label>
                        <textarea id="bootcampdescriptioninput" rows="5" placeholder="Descripción del bootcamp" class="form-control sin-borde rounded-8" v-model="bootcamp.description" required></textarea>
                        <small v-if="errors.description" class="text-danger">Debe ingresar la descripción del bootcamp</small>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-md-12">
                        <input type="text" v-model="bootcamp.cta_text" class="form-control rounded-8 sin-borde" placeholder="Mensaje del CTA" required>
                        <small v-if="errors.cta_text" class="text-danger">Debe ingresar el texto del call to action</small>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-md-12">
                        <input type="text" v-model="bootcamp.cta" class="form-control rounded-8 sin-borde" placeholder="Link del CTA" required>
                        <small v-if="errors.cta" class="text-danger">Debe ingresar la url del call to action</small>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-md-12">
                        <label class="bootcamp-label" for="bootcampfileinput">Ficha técnica</label>
                        <input type="file" id="bootcampfileinput" class="form-control rounded-8 sin-borde" accept="application/pdf" @change="onFileUpload">
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-md-12">
                        <label class="bootcamp-label" for="bootcampprogramtimeselect">Tiempo del programa</label>
                        <select id="bootcampprogramtimeselect" v-model="bootcamp.program_time"  class="form-control rounded-8 sin-borde">
                            <option value="5_meses">5 meses</option>
                            <option value="8_meses">8 meses</option>
                        </select>
                    </div>
                </div>

                <div class="d-flex my-4 flex-wrap flex-column flex-sm-row justify-content-end gap-2">
                    <button v-if="current_bootcamp" :disabled="loading" class="btn btn-outline-primary rounded-8 px-3 mx-3 mx-md-0" @click="onCancel">
                        Cancelar
                    </button>
                    <button :disabled="loading" class="btn px-3 btn-primary rounded-8 mx-3 mx-sm-0" @click="saveBootcamp">
                        {{ loading ? 'Procesando...' : 'Guardar bootcamp' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['get_url', 'current_bootcamp'],
        data(){
            return {
                bootcamp: this.current_bootcamp ? { ...this.current_bootcamp } : {
                    title: "",
                    description: "",
                    program_time: "5_meses",
                    cta: "",
                    cta_text: "Ver más"
                },
                errors: {
                    title: false,
                    description: false,
                    program_time: false,
                    cta: false,
                    cta_text: false,
                },
                loading: false,
                file: null,
                url: `${this.get_url}/${this.current_bootcamp ? this.current_bootcamp.id : ''}`
            }
        },
        methods: {
            onFileUpload( event ){
                this.file = event.target.files[0];
            },
            saveBootcamp() {
                if (!this.validate()) return;

                this.loading = true;
                const formData = this.buildFormData();
                if (this.current_bootcamp) {
                    this.sendUpdateRequest( formData );
                }else{
                    this.sendCreateRequest( formData );
                }
            },
            validate(){
                let isValid = true;
                for (const key in this.errors) {
                    const value = this.bootcamp[key];
                    if (value.trim().length < 1) {
                        this.errors[key] = true;
                        isValid = false;
                    }else{
                        this.errors[key] = false;
                    }
                }

                return isValid;
            },
            sendCreateRequest( formData ){
                axios.post(this.url, formData, {headers : {'content-type': 'multipart/form-data'}})
                    .then((res) => {
                        this.resetBootcamp();
                        this.loading = false;

                        this.$swal('Se ha creado exitosamente el Bootcamp.');
                        this.$emit('onsaved');
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            },
            sendUpdateRequest( formData ){
                axios.post(this.url, formData, {
                    headers : {'content-type': 'multipart/form-data'},
                    params: {_method: 'PUT'}
                })
                    .then((res) => {
                        this.resetBootcamp();
                        this.loading = false;

                        this.$swal('Se ha actualizado exitosamente el Bootcamp.');
                        this.$emit('onsaved');
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            },
            buildFormData(){
                const formData = new FormData();
                Object.entries(this.bootcamp).forEach(([key, value]) => {
                    formData.append(key, value);
                });
                if(this.file){
                    formData.append('ficha_tecnica' , this.file, this.file.name);
                }

                return formData;
            },
            resetBootcamp(){
                this.bootcamp = {
                    title: "",
                    description: "",
                    program_time: "5_meses",
                    cta: "",
                    cta_text: ""
                };

                this.file = null;
                document.getElementById('bootcampfileinput').value = '';
            },
            onCancel(){
                this.resetBootcamp();
                this.$emit('oncancel');
            }
        }
    }
</script>
<style>
    .page-title{
        color: #1A0054;
        font-weight: 700;
        font-size: 28px;
    }

    .bootcamp-label{
        color: #494949;
        font-size: 16px;
        font-weight: 600;
    }
</style>
